import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid } from '@material-ui/core';
import { Button, Card, StandardDialog, TextField } from '@roc/ui';
import { Add, Edit } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { AddReferrer } from './addReferrer';
import { Option } from '@roc/ui/utils';
import { ReferralsStore } from '../stores';
import { ReferralsService } from '../services';
import { LEAD_OBJECT_TYPE } from 'libs/feature-backoffice-users/src/backOfficeUsers/components/leads/constants/constants';

const useStyles = makeStyles(theme => ({
  button: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: '150px',
  },
  notesScroll: {
    backgroundColor: '#FAFAFA',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    maxHeight: '800px',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxShadow: '0 0 2px #DDD inset',
  },
}));

const useDialogContentStyles = makeStyles(theme => ({
  root: {
    paddingBottom: 24,
    paddingRight: 0,
  },
}));

export const ReferrerCardComponent = observer(
  ({ leadId }: { leadId: number }) => {
    const classes = useStyles();
    const dialogContentClasses = useDialogContentStyles();
    const { referralsStore, userStore } = useStore();
    const [referrerModalOpen, setReferrerModalOpen] = useState(false);

    useEffect(() => {
      referralsStore.getReferrer(leadId);
    }, []);

    const action = (
      <Box p={1} mb={-10}>
        <Button
          testId="update-referrer"
          className={classes.button}
          variant="contained"
          size="small"
          color="primary"
          onClick={() => {
            setReferrerModalOpen(true);
            referralsStore.selectedReferrer = referralsStore.referrer;
          }}
        >
          {referralsStore.referrer ? (
            <>
              <Edit /> Edit Info
            </>
          ) : (
            <>
              <Add /> Add Referrer
            </>
          )}
        </Button>
      </Box>
    );

    return (
      <Card
        title="Referrer"
        cardHeaderProps={{ action }}
        cardContentProps={{ className: classes.notesScroll }}
      >
        {referralsStore.referrer ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card
                title={`${referralsStore.referrer.firstName} ${referralsStore.referrer.lastName}`}
              >
                <Grid container item spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      testId={'referrer-email'}
                      value={referralsStore.referrer.emailAddress || referralsStore.referrer.email}
                      disabled={true}
                      label={'Email Address'}
                      standaloneLabel
                      fullWidth
                      variant={'outlined'}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      testId={'referrer-phone'}
                      value={referralsStore.referrer.cellPhone || referralsStore.referrer.phone}
                      disabled={true}
                      label={'Phone Number'}
                      fullWidth
                      variant={'outlined'}
                      standaloneLabel
                    />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Box textAlign="center">No records.</Box>
        )}
        <StandardDialog
          open={referrerModalOpen}
          handleClose={() => {
            setReferrerModalOpen(false);
            referralsStore.selectedReferrer = null;
            referralsStore.searchText = '';
          }}
          title={'Referrer'}
          subTitle={'Please link the person who referred this lead.'}
          dialogContent={<AddReferrer store={referralsStore} />}
          removeContentBox={true}
          dialogContentclasses={dialogContentClasses}
          dialogActions={
            <Grid container justifyContent={'space-between'}>
              <Button
                onClick={() => {
                  setReferrerModalOpen(false);
                  referralsStore.selectedReferrer = null;
                  referralsStore.searchText = '';
                }}
                variant="outlined"
                testId="cancel"
              >
                Cancel
              </Button>
              <Button
                onClick={async () => {
                  const companyId = userStore.userInformation.companyId ?? referralsStore.globalStore?.selectedCompanyId;
                  referralsStore.upsertReferrer(leadId, companyId,LEAD_OBJECT_TYPE);
                  setReferrerModalOpen(false);
                }}
                color="primary"
                variant="contained"
                testId="save"
                disabled={!referralsStore.createBorrower}
              >
                Confirm
              </Button>
            </Grid>
          }
        />
      </Card>
    );
  }
);
